import {useMemo} from "react";
import IndividualProfile from "./individual-profile.jsx";
import IndividualAge from "./individual-age.jsx";
import IndividualNationality from "./individual-nationality.jsx";

export default function ProfileCard({ data, setMode }) {
    const profiles = useMemo(() => {
        return Array.isArray(data?.indProfile)
            ? data.indProfile.map(item => ({
                profile: item?.profile ?? "",
                total: Number(item?.total || 0),
                reccurrent: Number(item?.reccurrent || 0),
            }))
            : [];
    }, [data]);

    return (
        <>
            { profiles.map((item) => (
                <section key={item.profile}>
                    <div className="report-divisor mb-3 print:break-after-avoid!">
                        <span className="divisor-title">PERFIL {item.profile.toUpperCase()}</span>
                    </div>

                    <IndividualProfile profileData={item} setMode={setMode}/>
                    <IndividualAge profileData={item} data={data} setMode={setMode}/>
                    <IndividualNationality profileData={item} data={data} setMode={setMode}/>
                </section>
            ))}
        </>
    )
}